'use strict';

const Mn = require('backbone.marionette');
const Template = require('feedback/ui/template/announcement/index.hbs');
const CoverView = require('feedback/ui/view/cover');
const AnnouncementListView = require('feedback/ui/view/announcement/list');
const AnnouncementCollectionFactory = require('feedback/domain/factory/announcement/collection');

const AnnouncementView = Mn.View.extend({
    tagName: 'div',
    className: 'announcement-list',
    template: Template,
    regions: {
        cover: '#cover',
        announcementList: '.announcement-list-wrapper'
    },

    templateContext: function() {
        return {
            isSiteAdmin: this.getOption('isSiteAdmin')
        }
    },

    onRender: function() {
        this.showChildView('cover', new CoverView({isAnnouncement: true}));

        const collection = AnnouncementCollectionFactory.getCollection();

        collection
            .fetchFirstPage()
            .then(() => {
                this.showChildView('announcementList', new AnnouncementListView({
                    collection: collection
                }));
            });
    }
});

module.exports = AnnouncementView;



// WEBPACK FOOTER //
// ./feedback/ui/view/announcement/index.js